<template>
  <div>
    <jd-dialog
      :title="`${isEdit ? '编辑' : '添加'}内容`"
      width="45%"
      sureText="保存"
      :visible.sync="isShowVisible"
      :before-close="cancelDialog"
      class="new-input-box"
      @confirm="submitForm"
      @close="cancelDialog"
    >
      <div class="dialog-content">
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleFormRef"
          label-width="auto"
        >
          <el-form-item label="选择模板:">
            <jd-button type="blueLine" @click="selectTemplateFn"
              >选择模板</jd-button
            >
            <jd-button type="blueText" v-if="!isEdit" @click="aiGenerateFn"
              >AI生成图文</jd-button
            >
          </el-form-item>
          <div class="content-box">
            <div
              class="content-box_item"
              v-for="(item, index) in formData.contentList"
              :key="item.id"
            >
              <div class="flex-between-box">
                <span>内容{{ index + 1 }}</span>
                <div>
                  <jd-button
                    type="blueText"
                    :disabled="!item.shareUrl || !item.shareContext"
                    v-loading="saveLoading"
                    @click="saveTemplateFn(item)"
                    v-if="!isEdit"
                    >存为模板</jd-button
                  >
                  <jd-button
                    type="blueText"
                    v-if="formData.contentList.length > 1"
                    @click="delContentFn(index)"
                    >删除</jd-button
                  >
                </div>
              </div>
              <el-form-item
                label="晒单图片:"
                :prop="`contentList[${index}].shareUrl`"
                :rules="[
                  {
                    required: true,
                    message: '请上传晒单图片',
                    trigger: ['change', 'blur'],
                  },
                ]"
              >
                <div class="upload-box">
                  <uploadCom
                    ref="postImgRef"
                    :imgUrl.sync="item.shareUrl"
                    :limitSize="2"
                  ></uploadCom>
                  <span class="upload-limit">建议尺寸：316*400px</span>
                </div>
              </el-form-item>
              <el-form-item
                label="晒单文案:"
                :prop="`contentList[${index}].shareContext`"
                :rules="[
                  {
                    required: true,
                    message: '请输入晒单文案',
                    trigger: 'blur',
                  },
                  {
                    max: 200,
                    message: '文案不能超过200个字符',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 4 }"
                  placeholder="请输入"
                  v-model="item.shareContext"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </div>
            <jd-button
              v-if="!isEdit"
              type="blueLine"
              class="mt16"
              :disabled="contentLength >= limitNum"
              @click="addContentFn"
              >添加内容（{{ contentLength }}/{{ limitNum }}）</jd-button
            >
          </div>
        </el-form>
      </div>
    </jd-dialog>
    <jd-dialog
      title="AI生成"
      width="45%"
      sureText="保存"
      :visible.sync="isShowAIVisible"
      :before-close="aiCancelDialog"
      v-if="isShowAIVisible"
      class="new-input-box"
      @confirm="aiSubmitForm"
      @close="aiCancelDialog"
    >
      <div class="dialog-content">
        <el-form
          :model="formData"
          :rules="aiRules"
          ref="aiRuleFormRef"
          label-width="auto"
        >
          <el-form-item label="生成内容关键词:" prop="keyWord">
            <el-input
              type="textarea"
              placeholder="例如“防晒、护肤，多个请用”、”隔开"
              v-model="formData.keyWord"
              class="w400"
              :autosize="{ minRows: 4, maxRows: 5 }"
              show-word-limit
              maxlength="100"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="生成内容:" prop="contentType">
            <el-radio-group
              v-model="formData.contentType"
              @change="changeContentType"
            >
              <el-radio :label="0">仅生成文案</el-radio>
              <el-radio :label="1">生成文案+图片</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="内容文案字数上限:" prop="contextMaxWord" v-if="formData.contentType == 1">
            <span class="mr8">最多可生成</span>
            <el-input
              placeholder="请输入"
              v-model="formData.contextMaxWord"
              @input="formData.contextMaxWord = handleInput($event)"
              class="w100"
            >
            </el-input>
            <span class="ml8">个文案字数</span>
          </el-form-item>
          <el-form-item
            label="图片素材:"
            prop="aiType"
            v-if="formData.contentType == 1"
          >
            <el-radio-group v-model="formData.aiType" @change="changeAiType">
              <el-radio :label="0">关键词生成</el-radio>
              <el-radio :label="1">选择商品</el-radio>
              <el-radio :label="2">自定义上传</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="formData.aiType == 1">
            <el-form-item label="选择商品:" prop="picUrl">
              <jd-button type="blue" @click="isShowGoods = true"
                >选择商品（{{ goodsList.length }}/1）</jd-button
              >
            </el-form-item>
          </div>
          <el-form-item
            label="上传图片:"
            prop="picUrl"
            v-if="formData.aiType == 2"
          >
            <div class="upload-box">
              <uploadCom
                ref="postImgRef"
                :imgUrl.sync="formData.picUrl"
                :limitSize="2"
              ></uploadCom>
              <span class="upload-limit">建议尺寸：316*400px</span>
            </div>
          </el-form-item>
          <el-form-item
            label="图片生成关键词:"
            prop="picKeyWord"
            v-if="formData.aiType == 1 || formData.aiType == 2"
          >
            <el-input
              type="textarea"
              placeholder="请描述你想要生成的图片场景"
              v-model="formData.picKeyWord"
              class="w400"
              :autosize="{ minRows: 4, maxRows: 5 }"
              show-word-limit
              maxlength="500"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="生成数量:" prop="generatedCount">
            <el-input
              placeholder="请输入"
              v-model="formData.generatedCount"
              @input="formData.generatedCount = handleInput($event)"
              class="w100"
            >
            </el-input>
            <span class="ml8">个AI内容，每个消耗1次AI生成次数</span>
          </el-form-item>
          <el-form-item label=" ">
            <div class="mt12 flex-box">
              <jd-button
                type="blue"
                :disabled="isDisabled"
                @click="generateContent"
                >{{ isShowLoading ? "生成中..." : "立即生成" }}</jd-button
              >
              <span class="ml8"
                >AI文案生成次数：{{ statsUsedData.textCount }}</span
              >
              <span class="ml12"
                >AI生成图片次数：{{ statsUsedData.imageCount }}</span
              >
              <el-tooltip
                class="item"
                effect="dark"
                content="如生成次数不足，请联系您的专属客服进行充值"
                placement="top"
              >
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/icon-question.png"
                  alt=""
                  class="question-icon"
                />
              </el-tooltip>

              <jd-button class="ml8" @click="viewHistory" type="blueText"
                >查看历史生成记录</jd-button
              >
            </div>
          </el-form-item>
          <div v-if="isGenerateSuccess">
            <div class="mb16">
              生成成功，选择指定生成数据，点击保存可配置至活动
            </div>
            <contentCom
              :tableInfo="tableInfo"
              :tableData.sync="contentList"
              :hasSelect="formData.contentList"
              :selection="selection"
              :loading="isShowLoading"
              @selectItemChange="handleSelectionChange"
            >
            </contentCom>
          </div>
        </el-form>
        <div
          class="loadding-box"
          v-if="isShowLoading"
          v-loading="isShowLoading"
          element-loading-text="AI内容生成中，请稍候..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.5)"
        ></div>
      </div>
      <historyRecord
        :isShow.sync="isShowHistory"
        v-if="isShowHistory"
        @use="handleUseHistory"
      />
    </jd-dialog>
    <jd-dialog
      title="注意"
      width="40%"
      :visible.sync="isShowConfirm"
      :before-close="closeFn"
      class="new-input-box"
      append-to-body
      :isShowSure="false"
      @close="closeFn"
    >
      <div class="text-center">
        <div>AI生成内容中，请勿关闭弹窗</div>
        <div>
          如需关闭，等待生成完成后可前往【查看历史生成记录】中查看生成结果
        </div>
      </div>
    </jd-dialog>
    <aiTemplate
      v-if="isShowTemplate"
      :isShow.sync="isShowTemplate"
      :isEdit="isEdit"
      :tableInfo="aiTemTableInfo"
      :contentList="formData.contentList"
      @selectItemChange="handleSelectionChange"
    />
    <selectGoodsMonitor
      v-if="isShowGoods"
      ref="selectGo"
      :isShow="isShowGoods"
      @close="selectGoodsClose"
      :selectGoods="goodsList"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="isLimit"
      :limitNum="limitCount"
      :isInteract="true"
    >
    </selectGoodsMonitor>
  </div>
</template>
<script>
import uploadCom from "@/views/interactiveMarketing/activity/components/commCustomizationSet/uploadCom.vue";
import contentCom from "@/views/interactiveMarketing/activity/xhsSunGift/components/contentCom.vue";
import historyRecord from "@/views/interactiveMarketing/activity/xhsSunGift/components/historyRecord.vue";
import aiTemplate from "@/views/interactiveMarketing/activity/xhsSunGift/components/aiTemplate.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import {
  getXhsAIGeneratedSummary,
  aiGenerate,
  aiGenerateResult,
  saveContentTemplate,
} from "@/api/jhk/paradiseAndTaskCommonController";
import { getAiUsageStats } from "@/api/jhk/aiSkin";
export default {
  components: {
    uploadCom,
    contentCom,
    historyRecord,
    aiTemplate,
    selectGoodsMonitor,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    limitNum: {
      type: Number,
      default: 20,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
    shareContentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectList: [],
      statsUsedData: {
        textCount: 0,
        imageCount: 0,
      },
      saveLoading: false,
      isShowGoods: false,
      isLimit: true,
      limitCount: 1,
      isShowAIVisible: false,
      isShowTemplate: false,
      isShowConfirm: false,
      isShowLoading: false,
      isShowHistory: false,
      contentList: [],
      selection: true,
      isGenerateSuccess: false,
      tableInfo: [
        {
          label: "排序",
          slot: "sortSlot",
          width: 120,
        },
        {
          label: "分享图",
          slot: "urlSlot",
          width: 160,
        },
        {
          label: "分享正文",
          prop: "content",
          type: "scalable",
          minWidth: 180,
        },
        {
          label: "操作",
          slot: "operationSlot",
          minWidth: 120,
        },
      ],
      rules: {
        contentList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请至少添加一条内容"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      aiRules: {
        keyWord: [
          { required: true, message: "请输入生成内容关键词", trigger: "blur" },
        ],
        contextMaxWord: [
          {
            required: true,
            message: "请输入内容文案字数上限",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value > 200) {
                callback(new Error(`内容文案字数上限不能超过200`));
                // 清空
                this.formData.contextMaxWord = "";
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        generatedCount: [
          // 大于20时，生成数量不能超过20
          { required: true, message: "请输入生成数量", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value > this.limitNum) {
                callback(
                  new Error(`每次生成仅可最多生成${this.limitNum}个内容`)
                );
                // 清空
                this.formData.generatedCount = "";
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        picUrl: [{ required: true, message: "请上传图片", trigger: "change" }],
        picKeyWord: [
          { required: true, message: "请输入图片生成关键词", trigger: "blur" },
        ],
      },
      formData: {
        shareContentSource: "手动编辑", //添加方式
        contentList: [
          {
            shareUrl: "", //图片url
            shareContext: "", //文案
            id: new Date().getTime(),
          },
        ], //内容列表
        keyWord: "", //关键词
        contextMaxWord: "", //文案数量
        generatedCount: "", //生成数量
        contentType: 0, //生成内容类型
        aiType: 0, //图片素材类型
        picKeyWord: "", //图片生成关键词
        picUrl: "", //图片url
      },
      goodsList: [],
      // aiNum: 0,
      aiSkinAnalyseDetailId: "",
      aiTemTableInfo: [
        {
          label: "分享图",
          slot: "urlSlot",
          width: 160,
        },
        {
          label: "分享正文",
          prop: "shareContext",
          type: "scalable",
          minWidth: 180,
        },
        {
          label: "操作",
          slot: "operationSlot",
          minWidth: 120,
        },
      ],
    };
  },
  computed: {
    isShowVisible: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit("update:isShow", val);
      },
    },
    isDisabled() {
      let flag = false;
      if (this.formData.contentType == 1 && this.formData.aiType != 0) {
        flag =
          !this.formData.keyWord ||
          !this.formData.contextMaxWord ||
          !this.formData.generatedCount ||
          !this.formData.picUrl ||
          !this.formData.picKeyWord;
      } else {
        flag =
          !this.formData.keyWord ||
          !this.formData.generatedCount
      }
      return (
        flag ||
        this.statsUsedData.imageCount <= 0 ||
        this.statsUsedData.textCount <= 0
      );
    },
    contentLength() {
      return this.shareContentList.length + this.formData.contentList.length;
    },
  },
  watch: {
    editData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.shareContentSource = "手动编辑";
          delete newVal.shareContentSource;
          this.formData.contentList = [newVal];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getStatsUsed() {
      getAiUsageStats()
        .then((res) => {
          if (res.code == 1 && res.data) {
            this.statsUsedData = res.data;
          }
        })
        .catch(() => {});
    },
    changeContentType() {
      this.formData.aiType = 0;
      this.formData.contextMaxWord = "";
      this.initData();
    },
    changeAiType() {
      this.initData();
    },
    initData() {
      this.formData.generatedCount = "";
      this.formData.picKeyWord = "";
      this.goodsList = [];
      this.formData.picUrl = "";
    },
    selectGoodsClose(data) {
      if (data) {
        const list = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          list.push(fomeVaule);
        });
        this.goodsList = list;
        if (list.length > 0) {
          this.formData.picUrl = list[0].logo;
        }
      }
      this.isShowGoods = false;
    },
    aiGenerateFn() {
      this.formData.keyWord = "";
      this.formData.contextMaxWord = "";
      this.formData.generatedCount = "";
      this.formData.shareContentSource = "AI生成";
      this.isShowAIVisible = true;
      this.isGenerateSuccess = false
      this.contentList = []
      this.selectList = []
      this.getStatsUsed();
      // this.getAINum();
    },
    saveTemplateFn(row) {
      this.saveLoading = true;
      // TODO:存为模板接口
      saveContentTemplate({
        shareUrl: row.shareUrl,
        shareContext: row.shareContext,
      })
        .then((res) => {
          this.saveLoading = false;
          if (res.code == 1) {
            this.$message.success("保存成功");
          }
        })
        .catch((err) => {
          this.saveLoading = false;
        });
    },
    selectTemplateFn() {
      this.isShowTemplate = true;
    },
    closeFn() {
      this.isShowConfirm = false;
    },
    getAINum() {
      getXhsAIGeneratedSummary()
        .then((res) => {
          if (res.code === 1) {
            this.aiNum = res.data;
          }
        })
        .catch((err) => {});
    },
    // 获取历史记录
    async getHistory() {
      try {
        this.isShowLoading = true;
        const res = await aiGenerateResult({
          recordId: this.aiSkinAnalyseDetailId,
        });
        this.isShowLoading = false;
        if (res.code == 1 && res.data.aiStatus == 1) {
          this.contentList = res.data.detailList;
          this.isGenerateSuccess = true;
        }
      } catch (error) {
        this.isShowLoading = false;
        this.$message.error("查询生成内容失败");
      }
    },
    // 使用历史记录
    handleUseHistory(row) {
      // 使用aiSkinAnalyseDetailId获取历史记录
      this.isGenerateSuccess = false;
      this.contentList = [];
      this.aiSkinAnalyseDetailId = row.id;
      this.getHistory();
    },
    handleSelectionChange(val, type = "ai") {
      if (!this.isEdit) {
        val.forEach((item) => {
          let params = {
            shareUrl: item.imageUrl,
            shareContext: item.content,
            id: item.id
          };
          if(type!="ai"){
            this.formData.contentList.push(params);
          } else {
            this.selectList.push(params);
          }
          
        });
      } else {
        const params = {
          shareUrl: val[0].imageUrl,
          shareContext: val[0].content,
        };
        if(type!="ai"){
          this.formData.contentList = [params];
        } else {
          this.selectList = [params];
        }
      }
    },
    changeWay(val) {
      if (val == "AI生成") {
        this.formData.contentList = [];
        this.getStatsUsed();
      } else {
        this.formData.contentList = [
          {
            shareUrl: "", //图片url
            shareContext: "", //文案
            id: new Date().getTime(),
          },
        ];
      }
      this.formData.keyWord = "";
      this.formData.contextMaxWord = "";
      this.formData.generatedCount = "";
    },
    // 处理输入框变化：必须是数字且需大于等于1
    handleInput(val) {
      // 使用replace方法移除非数字字符
      let newVal = val.replace(/[^\d]/g, "");
      if (Number(newVal) < 1) {
        newVal = "";
        return;
      }
      return newVal;
    },
    submitForm() {
      const obj = {
        shareContentSource: this.formData.shareContentSource,
        contentList: this.formData.contentList,
      };
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.$emit("submitForm", obj);
          this.$emit("update:isShow", false);
        } else {
          this.$message.error("请将信息填写完整");
        }
      });
    },
    // AI生成提交
    aiSubmitForm() {
      // const obj = {
      //   shareContentSource: this.formData.shareContentSource,
      //   contentList: this.formData.contentList,
      // };
      if (this.contentList.length === 0) {
        this.$message.error("请生成内容");
        return;
      }
      if (this.formData.contentList.length === 0) {
        this.$message.error("请选择指定生成数据");
        return;
      }
      this.isShowAIVisible = false;
      this.formData.contentList.push(...this.selectList);
      // this.$emit("submitForm", obj);
      // this.$emit("update:isShow", false);
    },
    viewHistory() {
      this.isShowHistory = true;
    },
    async generateContent() {
      const params = {
        keyWord: this.formData.keyWord,
        contextMaxWord: this.formData.contextMaxWord,
        generatedCount: this.formData.generatedCount,
        picKeyWord: this.formData.picKeyWord,
        aiType: this.formData.aiType,
        picUrl: this.formData.picUrl,
        contentType: this.formData.contentType,
      };
      this.isShowLoading = true;
      try {
        const res = await aiGenerate(params);
        if (res.code == 1 && res.data) {
          const recordId = res.data;
          const maxPollingTime = 10 * 60 * 1000;
          const pollingInterval = 1500;
          let pollingTime = 0;
          while (pollingTime < maxPollingTime) {
            await new Promise((resolve) =>
              setTimeout(resolve, pollingInterval)
            );
            pollingTime += pollingInterval;

            const result = await aiGenerateResult({ recordId });
            if (result.data.aiStatus == 0) {
              continue;
            } else if (result.data.aiStatus == 1) {
              this.contentList = result.data.detailList;
              this.isGenerateSuccess = true;
              this.$message.success(
                "列表展示生成内容，用户可勾选生成内容进行配置至活动页，可删除指定列表数据"
              );
              break;
            } else {
              this.$message.warning("网络繁忙稍后再试，并不扣除次数");
              break;
            }
          }
          this.getStatsUsed();
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("网络繁忙稍后再试，并不扣除次数");
      } finally {
        this.isShowLoading = false;
      }
    },
    delContentFn(index) {
      this.formData.contentList.splice(index, 1);
    },
    cancelDialog() {
      this.isShowVisible = false;
      this.$emit("update:isShow", false);
    },
    aiCancelDialog() {
      if (this.isShowLoading) {
        // 二次确认弹窗
        this.isShowConfirm = true;
        return;
      }
      this.isShowAIVisible = false;
      this.$refs.aiRuleFormRef.clearValidate();
    },
    addContentFn() {
      if (this.formData.contentList.length >= this.limitNum) {
        this.$message.warning(`最多只能添加${this.limitNum}条内容`);
        return;
      }
      this.formData.contentList.push({
        shareUrl: "",
        shareContext: "",
        id: new Date().getTime(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-content {
  position: relative;
  .content-box {
    max-height: 520px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      // height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f3f3f3;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 6px;
    }
    &_item {
      margin-bottom: 16px;
      padding: 16px;
      border-radius: 8px;
      background-color: #f5f7fa;
    }
    .flex-between-box {
      display: flex;
      line-height: 20px;
      margin-bottom: 12px;
      justify-content: space-between;
    }
  }
  .upload-box {
    display: flex;
    align-items: flex-end;
    .upload-limit {
      margin-left: 16px;
      color: #666666;
    }
  }
  .loadding-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 999;
  }
  .mt16 {
    margin-top: 16px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .mb16 {
    margin-bottom: 16px;
  }
  .ml8 {
    margin-left: 8px;
  }
  .mr8 {
    margin-right: 8px;
  }
  .w100 {
    width: 100px;
  }
  .w400 {
    width: 400px;
  }
}
.question-icon {
  margin-left: 4px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.flex-box {
  display: flex;
  align-items: center;
}
.text-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: normal;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
</style>
